import React from 'react'
import styled from 'styled-components'
import { Types } from '../../types'
import { MobileMenuContext } from '../../contexts/MobileMenu';
import Toggler from './Toggler'
import { Helpers } from '../../utils';
import Icon from '../Icon';

// Props extended interface
interface ICategory extends Types.AppOptions {
	// Top level boolean needed to prevent PrevHandler to be displayed if received true
	readonly topLevel: boolean
	// Title of the category
	readonly categoryTitle: string
}

/**
 * Category component to render a category line above the current menu
 * @param props ICategory
 * @returns React FC
 */
const Category: React.FC<ICategory> = (props) => {
	const { topLevel, categoryTitle, config } = props

	// Previous and collapse action handlers
	const { handlePrevious, handleBeforeReset, handleReset } = React.useContext(MobileMenuContext)
	return (
		<StyledCategory {...props}>
			{/* Previous action handler */}
			<PrevHandler onClick={!topLevel && handlePrevious}>
				<Toggler {...props} iconId={topLevel ? 'hamburger' : 'angleLeft'} />
			</PrevHandler>
			{/* Title */}
			<CategoryTitle {...props}>{categoryTitle}</CategoryTitle>
			{/* Collapse action handler */}
			<ResetHandler onClick={() => handleBeforeReset(config.general.timingBase)}>
				<Toggler {...props} iconId={'cross'} />
			</ResetHandler>
		</StyledCategory>
	)
}

// Grid-based category layout
const StyledCategory = styled.div<ICategory>`
  ${({ topLevel: tL, theme: t }) => `
  display: grid;
  grid-template-columns: min-content 1fr min-content;
  grid-template-areas: "Prev Title Reset";
  grid-column-gap: 1em;
  height: 4em;
  line-height: unset;
  padding: 0 1.5em;
  align-items: center;
  background: ${t.mobileMenu.categoryBackground};
  color: ${t.mobileMenu.categoryTextColor};
`}
`

const PrevHandler = styled.div`
  grid-area: Prev;
`

const CategoryTitle = styled.div<any>`
  ${({ theme }) => theme.mobileMenu.categoryTextSize === 'inherit'
		? `font-size: ${theme.mobileMenu.categoryTextSize}`
		: Helpers.clamp('font-size', 1, theme.mobileMenu.categoryTextSize, 4.25)
	}; // Jungle - X Ambassadors
  font-weight: ${({ theme }) => theme.mobileMenu.categoryTextBold};
  grid-area: Title;
`

const ResetHandler = styled.div`
  grid-area: Reset;
`

export default Category
